import { Container, Reveal, RevealGroup, Counter } from '@/components/common'
import { stats } from '@/constants/impact'

export const ImpactStats = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Creating <span className="text-ibon-dark/30">measurable change.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-6 text-lg leading-relaxed text-text-muted">
              We measure success by the opportunities created, the people reached, and the
              partnerships built through our programmes and initiatives.
            </p>
          </Reveal>
        </div>

        <RevealGroup className="mt-16 grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-3" step={90}>
          {stats.map((stat) => (
            <div key={stat.label} className="border-l-2 border-ibon-sky pl-5">
              <div className="text-5xl font-bold tracking-tight text-ibon-dark sm:text-6xl">
                <Counter value={stat.value} suffix={stat.suffix} />
              </div>
              <p className="mt-3 text-sm font-medium uppercase tracking-wide text-text-muted">
                {stat.label}
              </p>
            </div>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
